import React from 'react'
import { Link } from 'react-router-dom'

const SideBarItem = ({
    activeTab,
    label,
    message,
    path,
    isCollapsed,
    onClick,
    icon,
}) => {
    return (
        <li className="nav-item">
            <Link
                className={`nav-link sidenav-items sidenav-items ${activeTab === message ? "active" : ""
                    }`}
                to={path}
                onClick={() => onClick(message)}
                aria-current="page"
            >
                <div className="db-icons">{icon}</div>
                {!isCollapsed && (
                    <Link to={path} onClick={() => onClick(message)}>
                        <div className="list-item">{label}</div>
                    </Link>
                )}
            </Link>
        </li>
    )
}

export default SideBarItem